import React from 'react';
import { Heart, ShieldAlert, Briefcase, PiggyBank, Home, Car, Scale, Plane, Building2 } from 'lucide-react';
import { CalculatorCard } from '../components/CalculatorCard';
import { Button } from '../components/ui/Button';
interface RechnerPageProps {
  onNavigate: (page: string) => void;
}
export function RechnerPage({
  onNavigate
}: RechnerPageProps) {
  const calculators = [{
    title: 'Krankenversicherung',
    description: 'Vergleichen Sie PKV und GKV Tarife. Finden Sie den besten Schutz für Ihre Gesundheit.',
    icon: Heart
  }, {
    title: 'Privathaftpflicht',
    description: 'Der wichtigste Schutz im Alltag. Schon ab wenigen Euro im Monat absichern.',
    icon: ShieldAlert
  }, {
    title: 'Berufsunfähigkeit',
    description: 'Sichern Sie Ihre Arbeitskraft ab. Existenziell wichtig für fast jeden Berufstätigen.',
    icon: Briefcase
  }, {
    title: 'Altersvorsorge',
    description: 'Sorgen Sie heute für morgen vor. Renten- und Vorsorgepläne im Vergleich.',
    icon: PiggyBank
  }, {
    title: 'Hausrat & Wohngebäude',
    description: 'Schutz für Ihr Hab und Gut. Gegen Feuer, Wasser, Einbruch und mehr.',
    icon: Home
  }, {
    title: 'Kfz-Versicherung',
    description: 'Sparen Sie beim Wechsel Ihrer Autoversicherung. Bis zu 850€ Ersparnis möglich.',
    icon: Car
  }, {
    title: 'Rechtsschutz',
    description: 'Ihr gutes Recht durchsetzen. Ohne Kostenrisiko bei Streitigkeiten.',
    icon: Scale
  }, {
    title: 'Reiseversicherung',
    description: 'Entspannt in den Urlaub. Reiserücktritt und Auslandskrankenschutz.',
    icon: Plane
  }, {
    title: 'Gewerbeversicherung',
    description: 'Maßgeschneiderter Schutz für Selbstständige und Unternehmen.',
    icon: Building2
  }];
  return <div className="min-h-screen bg-slate-50" data-id="element-589">
      <div className="bg-white py-20 border-b border-slate-200 shadow-sm" data-id="element-590">
        <div className="container mx-auto px-4 text-center" data-id="element-591">
          <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6" data-id="element-592">
            Versicherungsrechner
          </h1>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto leading-relaxed" data-id="element-593">
            Vergleichen Sie Premium-Tarife in wenigen Minuten und sparen Sie
            bares Geld. Einfach, anonym und unverbindlich.
          </p>
        </div>
      </div>

      <div className="container mx-auto px-4 py-20" data-id="element-594">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-595">
          {calculators.map((calc, index) => <CalculatorCard key={index} title={calc.title} description={calc.description} icon={calc.icon} onClick={() => {
          console.log(`Open calculator: ${calc.title}`);
        }} data-id="element-596" />)}
        </div>
      </div>

      <div className="container mx-auto px-4 py-12 mb-20" data-id="element-597">
        <div className="bg-gradient-to-r from-blue-600 to-indigo-700 rounded-3xl p-10 md:p-16 text-center shadow-2xl relative overflow-hidden" data-id="element-598">
          <div className="absolute top-0 left-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10" data-id="element-599"></div>
          <div className="relative z-10" data-id="element-600">
            <h2 className="text-3xl font-bold text-white mb-6" data-id="element-601">
              Nicht sicher, was Sie brauchen?
            </h2>
            <p className="text-blue-100 mb-10 max-w-2xl mx-auto text-lg" data-id="element-602">
              Nutzen Sie unseren KI-Bedarfscheck oder lassen Sie sich von
              unseren Experten beraten. Wir helfen Ihnen, den richtigen Schutz
              zu finden.
            </p>
            <Button onClick={() => onNavigate('beratung')} size="lg" className="bg-white text-blue-700 hover:bg-blue-50 border-0 font-bold px-10 h-14 text-lg shadow-lg" data-id="element-603">
              Kostenlose Beratung anfragen
            </Button>
          </div>
        </div>
      </div>
    </div>;
}